namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201_DiscRow {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        LineItemType?: string;
        ItemDesc?: string;
        DiscCouponType?: string;
        DiscCouponNo?: string;
        PromoId?: string;
        DiscPc?: number;
        Discamt?: number;
        ChargePc?: number;
        ChargeAmt?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace Report_1201_DiscRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'ReportMasterData.Report_1201_Disc';
        export const lookupKey = 'Report_1201_DiscRow';

        export function getLookup(): Q.Lookup<Report_1201_DiscRow> {
            return Q.getLookup<Report_1201_DiscRow>('Report_1201_DiscRow');
        }
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            LineItemType = "LineItemType",
            ItemDesc = "ItemDesc",
            DiscCouponType = "DiscCouponType",
            DiscCouponNo = "DiscCouponNo",
            PromoId = "PromoId",
            DiscPc = "DiscPc",
            Discamt = "Discamt",
            ChargePc = "ChargePc",
            ChargeAmt = "ChargeAmt",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
